
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#545252","d":"M27.999 0L0 16.75v33.5L28 67l28-16.75v-33.5L28 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M22.902 44.56h5.732c.596 0 1.254-.062 1.972-.185a5.867 5.867 0 002.012-.737 5.037 5.037 0 001.586-1.495c.432-.628.65-1.46.65-2.5 0-1.72-.556-3.01-1.667-3.87-1.112-.86-2.616-1.29-4.512-1.29h-5.773V44.56zm0-13.518h5.326c.732 0 1.422-.075 2.073-.225a4.63 4.63 0 001.707-.758 3.833 3.833 0 001.159-1.351c.285-.547.427-1.215.427-2.008 0-1.146-.366-2.143-1.098-2.99-.732-.846-1.884-1.27-3.455-1.27h-6.139v8.602zM19 19h10c1.247 0 2.405.15 3.476.45 1.07.302 1.991.745 2.764 1.332a6.21 6.21 0 011.83 2.253c.446.914.67 1.986.67 3.214 0 1.667-.46 3.026-1.382 4.076-.922 1.052-2.114 1.823-3.578 2.315v.081c.868.056 1.68.281 2.44.677a6.673 6.673 0 011.972 1.556 7.498 7.498 0 011.32 2.232c.326.847.488 1.762.488 2.745 0 1.31-.264 2.464-.793 3.46a7.433 7.433 0 01-2.174 2.52c-.922.683-1.992 1.202-3.212 1.557-1.22.355-2.534.532-3.943.532H19V19z"}})])])
          )
        }
      }
    